export default {
  title: 'Sistema de registro de Incidentes',
  subtitle: 'Comprometidos con brindarte una experiencia sin contratiempos que afecten tus operaciones diarias, hemos diseñado este portal de soporte para que puedas informarnos sobre cualquier incidente o problema relacionado con tus productos adquiridos.',
  btnAccess: 'Acceder con cuenta y contraseña',
  section_one: {
    title: '¿Qué pasa luego de reportar una incidencia?'
  },
  section_two: {
    title: 'Aspectos importantes a considerar antes de reportar un incidente'
  },
  cards: {
    card1: {
      number: 1,
      content: 'Recibimos la solicitud y te asignamos un número de ticket de forma inmediata para que puedas dar seguimiento al reporte.'
    },
    card2: {
      number: 2,
      content: 'Derivamos el caso a los profesionales pertinentes.'
    },
    card3: {
      number: 3,
      content: 'Realizamos una investigación para obtener un diagnóstico lo antes posible.'
    },
    card4: {
      number: 4,
      content: 'Se da resolución al caso, cerrando el ticket o solicitando información adicional para solucionarlo eficazmente.'
    },
    card5: {
      number: 5,
      content: 'Comprobamos que la solución entregada resuelve el problema y generamos un informe correspondiente al caso.'
    }
  },
  cards_two: {
    card1: {
      title: 'Evidencia',
      content: 'Asegúrate de presentar la mayor cantidad de evidencias posibles, para que la resolución sea ágil y acortemos los tiempos de diagnóstico.'
    },
    card2: {
      title: 'Proyecto',
      content: 'Ten claridad a qué proyecto está asignando el incidente.Ten claridad a qué proyecto está asignando el incidente.'
    },
    card3: {
      title: 'Ticket',
      content: 'Conserva tu número de ticket para hacer seguimiento.'
    }
  }
}
